import { Box } from '@mui/material';
import AiChatFileAttachment from './AiChatFileAttachment';

interface AiChatUserMessageProps {
  content: string;
  documents?: Array<{ id: number; url: string; title: string }>;
}

export default function AiChatUserMessage({ content, documents = [] }: AiChatUserMessageProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignSelf: 'flex-end', maxWidth: '80%', gap: 1 }}>
      <Box
        sx={{
          backgroundColor: 'var(--color-neutral-2)',
          px: 3,
          py: 2,
          borderRadius: 3,
          borderBottomRightRadius: '2px',
        }}
      >
        {content}
      </Box>
      {documents.length > 0 && (
        <Box sx={{ gap: 2, display: 'flex' }}>
          {documents.map((document) => (
            <AiChatFileAttachment key={document.id} document={document} mode="view" />
          ))}
        </Box>
      )}
    </Box>
  );
}
